import { get } from 'services/api/base';

import { PosCampaignProposal, FetchPosCampaignProposalRequest } from './types-fetch-campaign-proposal';

export function fetchPosCampaignProposal(request: FetchPosCampaignProposalRequest): Promise<PosCampaignProposal> {
  return get(`v5/pos/campaign-proposals/${request.id}`).json();
}
